<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3}">
    <!-- .custom-text-type-1 === ctt1 -->
    <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
      <div class="ctt1" @click.prevent="setVisible()">
        <div class="ctt1-box custom-item" :style="{'background': searchModal.background}">
          <!-- 内容 -->
          <div
            style="width:100%;word-wrap:break-word;word-break:normal;padding:0 10px"
            :style="setStyle"
          >
            <i class="icon iconfont icon-search"></i>
            <template v-if="searchModal.words[0]">
              {{searchModal.words[0]}}
            </template>
            <template v-else>
              点击编辑搜索内容
            </template>
          </div>

          <!-- 关闭按钮 -->
          <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
        </div>
      </div>
      <div slot="content" class="ctt1-poptip">
        <div class="ctt1p-title">Product search settings</div>

        <!-- 设置内容 -->
        <div class="ctt1p-content">
          <Form :label-width="170" :model="formInline" style="width:100%;">
            <FormItem label="Hot words for searching:">
              <!-- 鼠标拖拽调整热词顺序， -->
              <div style="font-size: 12px;color: #b3b3b3;cursor:pointer;line-height: initial;padding-top: 8px;">
                搜索框默认展示第一个热词，其他搜索词将以标签形式在搜索页中
                <!-- <span
                  style="margin-left:10px;color:#1890ff;cursor:pointer;line-height: initial;padding-top: 8px;"
                >查看示例</span> -->
              </div>
              <div class="ctt1p-content-hotword-b">
                <div
                  class="hotword"
                  v-for="(item,index) in searchModal.words"
                  :key="'hotword' + index"
                >
                  <i class="icon iconfont icon-guanbi" @click="delHotword(index)"></i>
                  <Input v-model="searchModal.words[index]" placeholder="Hot words for searching"/>
                </div>
                <div class="add" @click="addHotword">
                  <i class="icon iconfont icon-add2"></i>Add hot words
                </div>
              </div>
            </FormItem>
            <FormItem label="Frame style:">
              <RadioGroup v-model="formInline.style" type="button" @on-change="changeStyle">
                <Radio label="Square"></Radio>
                <Radio label="Round"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="Background color:">
              <ColorPicker v-model="searchModal.background" />
              <Button style="margin-left:20px;" @click="searchModal.background = '#fff'">Reset</Button>
            </FormItem>
            <FormItem label="Frame color:">
              <ColorPicker v-model="searchModal.borderColor" />
              <Button style="margin-left:20px;" @click="searchModal.borderColor = '#eee'">Reset</Button>
            </FormItem>
            <FormItem label="Text position:">
              <RadioGroup
                v-model="formInline.positionValue"
                type="button"
                @on-change="changePosition"
              >
                <Radio label="Left"></Radio>
                <Radio label="Center"></Radio>
                <Radio label="Right"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="Text color:">
              <ColorPicker v-model="searchModal.color" />
              <Button style="margin-left:20px;" @click="searchModal.color = '#000'">Reset</Button>
            </FormItem>
          </Form>
          <div style="text-align:right;">
            <Button type="primary" @click.prevent="setVisible()">Save</Button>
          </div>
        </div>

        <!-- <a @click="visible=false">关闭</a> -->
      </div>
    </popper>
    <!-- 上方增加键 -->
    <Poptip v-model="visible2" placement="right-start" width="411" class="custom-add-wrapper z-top">
      <img src="@/assets/img/custom/add.png" />
      <div slot="content" class="ctt1-poptip">
        <div class="ct-components">
          <div class="ctc-title">Add</div>
          <div class="ctc-group">
            <div
              class="ctc-item"
              v-for="(item, index) in commmonArr"
              :key="'commmon-' + index"
              @click="add(item, 'top')"
            >
              <i class="icon iconfont" :class="item.icon"></i>
              <div class="ctc-item-txt">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </Poptip>
    <!-- 下方增加键 -->
    <Poptip
      v-model="visible3"
      placement="right-start"
      width="411"
      class="custom-add-wrapper z-bottom"
    >
      <img src="@/assets/img/custom/add.png" />
      <div slot="content" class="ctt1-poptip">
        <div class="ct-components">
          <div class="ctc-title">Add</div>
          <div class="ctc-group">
            <div
              class="ctc-item"
              v-for="(item, index) in commmonArr"
              :key="'commmon-' + index"
              @click="add(item, 'bottom')"
            >
              <i class="icon iconfont" :class="item.icon"></i>
              <div class="ctc-item-txt">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </Poptip>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import popper from "@components/En/vue-popper/VuePopper.vue";

export default {
  // 标题类型 1
  name: "custom-text-type-1",
  model: {
    prop: "searchModal",
    event: "sendSearchModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: {
        type: 1, // 文本类型 暂时只有 1
        content: "", // 文本内容
        fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
        color: "#000", // 文字颜色 默认黑色
        position: "left" // 文本对齐格式
      }
    },
    searchModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 搜索类型 暂时只有 1
          words: [],
          style: "circular", // 搜索外边框样式 （圆 \ 方）
          position: "left", // 文本对齐格式
          color: "#ccc",
          background: "#fff",
          borderColor: "#eee"
        };
      }
    }
  },
  data() {
    return {
      visible: false,
      visible2: false,
      visible3: false,

      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: ""
            }
          }
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [{
            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: "",
            url: ""
          }]
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: [""],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec"
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      
      formInline: {
        style: "方形",
        positionValue: "居左显示"
      }
    };
  },
  computed: {
    type() {
      return this.info.type;
    },
    setStyle() {
      return {
        color: this.searchModal.color,
        "text-align": this.searchModal.position,
        background: this.searchModal.borderColor,
        "border-radius": this.formInline.style === "圆形" ? "15px" : "0"
      };
    },
    ...mapGetters({
      activeIndex: "customComponentModule/getActiveIndex"
    })
  },
  components: {
    popper
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== this.index) this.visible = false;
    }
  },
  created() {
    if (this.index === this.activeIndex) {
      this.visible = true;
    }
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    addComponent() {
      this.visible = false;
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
      
      
    },
    close() {
      this.$emit("close");
    },
    changeStyle(value) {
      if (value === "方形") {
        this.searchModal.style = "square";
      }
      if (value === "圆形") {
        this.searchModal.style = "circular";
      }
    },
    changePosition(value) {
      if (value === "居左显示") {
        this.searchModal.position = "left";
      }
      if (value === "居中显示") {
        this.searchModal.position = "center";
      }
      if (value === "居右显示") {
        this.searchModal.position = "right";
      }
    },
    addHotword() {
      this.searchModal.words.push("");
    },
    delHotword(index) {
      this.searchModal.words.splice(index, 1);
    },
    init() {
      if (this.searchModal && this.searchModal.style) {
        if (this.searchModal.style === "circular") {
          this.formInline.style = "方形";
        }
        if (this.searchModal.style === "square") {
          this.formInline.style = "圆形";
        }
      }
      if (this.searchModal && this.searchModal.position) {
        switch (this.searchModal.position) {
          case "left":
            this.formInline.positionValue = "居左显示";
            break;
          case "center":
            this.formInline.positionValue = "居中显示";
            break;
          case "right":
            this.formInline.positionValue = "居右显示";
            break;
        }
      }
    }
  },
  mounted() {
    this.init();
    if (this.index === 0) {
      this.visible = true;
      this.setActiveIndex(this.index);
    }
  }
};
</script>

<style scoped lang="scss">
.ctt1 {
  width: 100%;
  &-box {
    background-color: #fff;
    padding: 10px;
    cursor: pointer;
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 20px 20px;
        &-hotword {
          &-t {
            display: inline-block;
            word-wrap: break-word;
            white-space: pre-wrap;
            line-height: 12px;
            font-size: 12px;
            color: #b3b3b3;
            padding-top: 10px;
          }
          &-b {
            .hotword {
              border: dashed 1px #bfbfbf;
              margin: 10px 0;
              border-radius: 4px;
              padding: 5px 10px 5px 10px;
              position: relative;
              &:hover {
                i {
                  visibility: visible;
                }
              }
              i {
                visibility: hidden;
                position: absolute;
                top: -15px;
                right: -12px;
                font-size: 25px;
                cursor: pointer;
              }
            }
            .add {
              border: dashed 1px #bfbfbf;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #1890ff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
</style>
